import { useCallback, useMemo } from 'react';
import { ConceptCode } from '@tiendanube/common';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { useChargeCreation } from '../pages/PlansAndSubscriptions/components/PaymentsTabs/components/SelectChargesToPayTab/hooks';
import { usePendingCharges } from '../pages/PlansAndSubscriptions/hooks';

export default function usePaySingleCharge(
  concept: ConceptCode | undefined,
  externalReference: string | undefined,
  initialFetch: boolean,
) {
  const { groupedCharges, status: chargesStatus } =
    usePendingCharges(initialFetch);
  const { onContinue, status } = useChargeCreation(initialFetch);

  const chargesToPay = useMemo(
    () =>
      concept &&
      groupedCharges
        ?.filter((group) =>
          group.some(
            ({ conceptCode, metadata }) =>
              conceptCode === concept &&
              (!externalReference || externalReference === metadata?.appId),
          ),
        )
        .flat(),
    [groupedCharges, concept, externalReference],
  );

  const onPay = useCallback(() => {
    if (!chargesToPay) return;
    onContinue(chargesToPay);
  }, [onContinue, chargesToPay]);

  return {
    onPay,
    setupStatus: {
      status: chargesStatus,
      ...convertStatusTypeToObject(chargesStatus),
    },
    executionStatus: { status, ...convertStatusTypeToObject(status) },
  };
}
